const SERVER_ERROR_VALIDATE_CODES = [
  2100, 2101, 2102, 2103, 2106, 2107, 2108, 2109, 2110, 2111, 2112, 2113, 2114, 2115, 2116,
  //* form validation codes *//
  12101, 12102, 12103, 12104, 12105, 12106, 12107,
  4102, 4103, 4104, 4105, 4106, 4107, 4108, 4109, 41010,
  //* end form validation codes*//
  5000, 5001, 5002, 5003,
  7003, 7004, 7005, 7006, 7008, 7009, 7010, 7011,
  //* Time out*//
  401,
];
export const isValidateFormError = (errorCode) => SERVER_ERROR_VALIDATE_CODES.includes(errorCode);
